import React from 'react';
import PlayIcon from '@assets/icons/play.svg';
import { BaseAlertBanner as AlertBanner, BaseButton } from '@components';
import { LEARNING_PATH_TYPES } from '@constants/learningStates.ts';
import { useAppSelector } from '@hooks/reduxHooks.ts';
import { useCustomNavigate } from '@hooks/useCustomNavigate.ts';
import { useLingui } from '@lingui/react/macro';
import { ROUTES } from '@router/constants.ts';

import { WelcomeSectionWrapper } from './styled.tsx';

const WelcomeSection: React.FC = () => {
    const { t } = useLingui();
    const navigate = useCustomNavigate();
    const userFullInfo = useAppSelector((state) => state.user.userInfo);

    const learningResultsDescription = useAppSelector(
        (state) => state.learning.learningCards[LEARNING_PATH_TYPES.Mandatory].resultsDescription,
    );

    const name = userFullInfo?.userPersonalData?.firstName || '';
    const lastVisitedPathwayId = learningResultsDescription?.lastPathwayIdUsed;

    const showResumeLearningButton = lastVisitedPathwayId ?? false;

    const handleResumeLearningClick = () => {
        const pathwayRoute = `${ROUTES.SIDEBAR.LEARNING}/${lastVisitedPathwayId}`;
        if (lastVisitedPathwayId) {
            navigate(pathwayRoute);
        }
    };

    return (
        <WelcomeSectionWrapper>
            <AlertBanner
                action={
                    showResumeLearningButton ? (
                        <BaseButton iconPlacement={'end'} icon={<PlayIcon />} onClick={handleResumeLearningClick}>
                            {t`Resume recent learning`}
                        </BaseButton>
                    ) : null
                }
                showIcon={false}
                type="info"
                title={t`Hello ${name}!`}
                description={t`Every login is progress. Let’s build on it.`}
            />
        </WelcomeSectionWrapper>
    );
};

export default WelcomeSection;
